import { render } from "./CategorySidebar.vue?vue&type=template&id=2b9a3c66&scoped=true"
import script from "./CategorySidebar.vue?vue&type=script&lang=js"
export * from "./CategorySidebar.vue?vue&type=script&lang=js"

import "./CategorySidebar.vue?vue&type=style&index=0&id=2b9a3c66&scoped=true&lang=scss"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9a3c66"]])

export default __exports__